/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 1.0.0
 * @file Manages data util about gis
 */
import ol from "openlayers";

/**
 * Constant data url web map server
 * @type {string}
 */
export const URL_WMS = "http://54.235.226.218:80/geoserver/";
/**
 * Constant data general namespacewms
 * @type {string}
 */
export const NAMESPACE_WMS = "base/wms";
export const NAMESPACE_WMS_BUS = "business/wms";
/**
 * Namespace about unit business data center in EPSG:4326
 * @type {{CULIACAN: {lon: number, lat: number}, TIJUANA: {lon: number, lat: number}, VALLARTA: {lon: number, lat: number}}}
 */
const UNIT_BUS_4326 = {
  CULIACAN: {lon: -107.3940117, lat: 24.8090649},
  TIJUANA: {lon: -117.046623, lat: 32.522499},
  VALLARTA: {lon: -105.26670, lat: 20.61667}
}

/**
 * Function to get unit business center data
 * @param data
 * @returns {*}
 */
export function getLonLat(data) {
  var unitBus = null;
  switch (data) {
    case 1:
      unitBus = UNIT_BUS_4326.CULIACAN;
      break;
    case 2:
      unitBus = UNIT_BUS_4326.VALLARTA;
      break;
    case 3:
      unitBus = UNIT_BUS_4326.TIJUANA;
      break;
  }
  return unitBus;
}

/**
 * Function to get layers
 * @param data
 * @returns {*[]}
 */
export function getLayers(data) {

  var layers = new Array();
  layers = baseLayer();
  switch (data) {
    case 1:
      layers = layers.concat(baseCuliacan());
      break;
    case 2:
      layers = layers.concat(baseVallarta());
      break;
    case 3:
      layers = layers.concat(baseTijuana());
      break;
  }
  return layers;

}

/**
 * Function that permit charge data base layer information
 * @returns {*[]}
 */
function baseLayer() {
  return [
    new ol.layer.Group({
      'title': 'Base',
      layers: [
        new ol.layer.Tile({
          source: new ol.source.OSM(),
          name: 'baseMap'
        })
      ]
    })]
}

/**
 * Function that permit charge data layer about Tijuana
 * @returns {*[]}
 */
function baseTijuana() {
  return [
    new ol.layer.Group({
      title: 'Tijuana',
      layers: [
        new ol.layer.Tile({
          visible: true,
          name: 'Localidad',
          source: new ol.source.TileWMS({
            url: URL_WMS + NAMESPACE_WMS,
            params: {
              tiled: true,
              LAYERS: 'base:localidad_02'
            }
          })
        }),
        new ol.layer.Tile({
          visible: true,
          name: 'Manzana',
          source: new ol.source.TileWMS({
            url: URL_WMS + NAMESPACE_WMS,
            params: {
              tiled: true,
              LAYERS: 'base:manzana_02'
            }
          })
        })
      ]
    })]
}

/**
 * Function that permit charge data layer about Vallarta
 */
function baseVallarta() {
  return [new ol.layer.Group({
    title: 'Vallarta',
    layers: [
      new ol.layer.Tile({
        visible: true,
        name: 'Distrito electoral',
        source: new ol.source.TileWMS({
          url: URL_WMS + NAMESPACE_WMS_BUS,
          params: {
            tiled: true,
            LAYERS: 'business:dist_elect_vallarta'
          }
        })
      }),
      new ol.layer.Tile({
        visible: true,
        name: 'Sección electoral',
        source: new ol.source.TileWMS({
          url: URL_WMS + NAMESPACE_WMS_BUS,
          params: {
            tiled: true,
            LAYERS: 'business:seccion_elect_vallarta'
          }
        })
      }),
      new ol.layer.Tile({
        visible: true,
        name: 'Zona catastral',
        source: new ol.source.TileWMS({
          url: URL_WMS + NAMESPACE_WMS_BUS,
          params: {
            tiled: true,
            LAYERS: '	business:zon_cat_vallarta'
          }
        })
      }),
      new ol.layer.Tile({
        visible: true,
        name: 'Zona de valor',
        source: new ol.source.TileWMS({
          url: URL_WMS + NAMESPACE_WMS_BUS,
          params: {
            tiled: true,
            LAYERS: 'business:zon_val_vallarta'
          }
        })
      })
    ]
  })]
}

/**
 * Function that permit charge data layer about Culiacán
 * @returns {*[]}
 */
function baseCuliacan() {
  return [
    new ol.layer.Group({
      title: 'Culiacán',
      layers: [
        new ol.layer.Tile({
          visible: true,
          name: 'Distrito electoral',
          source: new ol.source.TileWMS({
            url: URL_WMS + NAMESPACE_WMS_BUS,
            params: {
              tiled: true,
              LAYERS: 'business:dist_elect'
            }
          })
        }),
        new ol.layer.Tile({
          visible: true,
          name: 'Al corriente',
          source: new ol.source.TileWMS({
            url: URL_WMS + NAMESPACE_WMS_BUS,
            params: {
              tiled: true,
              LAYERS: 'business:corriente'
            }
          })
        }),
        new ol.layer.Tile({
          visible: true,
          name: 'Rezago',
          source: new ol.source.TileWMS({
            url: URL_WMS + NAMESPACE_WMS_BUS,
            params: {
              tiled: true,
              LAYERS: 'business:rezago'
            }
          })
        })
      ]
    })
  ]
}



// WEBPACK FOOTER //
// ./src/utils/map.js